import styled from 'styled-components';
import { spacing } from 'ui/theme';

export const QueryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${spacing.base};
`;
